import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { BasePanel } from "~/components/base-panel";
import { EmptyList } from "~/components/empty/empty-list";
import { useQualifiersData } from "./use-qualifiers-data";
import { QualifiersListVariant } from "./types";
import { SubjectItem } from "~/pages/product-details/tabs/thema-tab/components/subject-item";

interface QualifiersListProps {
  variant?: QualifiersListVariant;
}

export const QualifiersList = ({
  variant = "generated",
}: QualifiersListProps) => {
  const { t } = useTranslation(["productDetails"]);
  const { qualifiers, finalQualifiers, isEmptyList } =
    useQualifiersData(variant);

  const finalQualifierCodes = useMemo(
    () => finalQualifiers.map((qualifier) => qualifier.subjectCode),
    [finalQualifiers],
  );

  return (
    <BasePanel
      isEmpty={isEmptyList}
      headerClassName="bg-transparent"
      border={false}
      emptyComponent={
        <EmptyList
          title={
            variant === "generated"
              ? t("thema.sections.noQualifiers.generated.title")
              : t("thema.sections.noQualifiers.database.title")
          }
          text={
            variant === "generated"
              ? t("thema.sections.noQualifiers.generated.description")
              : t("thema.sections.noQualifiers.database.description")
          }
        />
      }
    >
      {qualifiers.map((item) => (
        <SubjectItem
          key={item.id}
          testId={`add-qualifier-${variant}-${item.subjectCode}-button`}
          subject={item}
          isSelected={finalQualifierCodes.includes(item.subjectCode)}
          className="px-5"
        />
      ))}
    </BasePanel>
  );
};
